"use client";
import { getSession } from "@/utils/auth";
import { useEffect, useState } from "react";

export function useAuthUser() {
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    const getToken = async () => {
      const config = await getSession();
      if (config?.user) {
        setUser(config?.user);
      }
    };
    getToken();
  }, []);

  return user;
}

export function useAuthRole() {
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    if (storedRole) {
      setRole(storedRole);
    }
  }, []);

  return role;
}
